export enum DiversionType {
    DESTINATION_DIVERSION = 'L',
    RETURN_DIVERSION = 'O',
    STORAGE_DIVERSION = 'Q',
    SHOP_DIVERSION = 'S',
}
